import ROUTES from '@/routes/routes'
import { ArrowLeftCircle } from 'lucide-react'
import { NavLink, useParams } from 'react-router-dom'

const AdjudicationContext = () => {
  const params = useParams()
  const roomId = params.roomId as string
  return (
    <>
      <div className='h-auto w-full space-y-3'>
        <div className='flex items-center gap-x-2'>
          <NavLink
            to={ROUTES.PROFESSOR.MONITORING(roomId)}
            className='flex-shrink-0'
          >
            <ArrowLeftCircle className='text-dark-blue hover:text-dark-blue-hovered' />
          </NavLink>
          <h1 className='text-2xl font-bold text-dark-blue'>
            Decision Adjudication
          </h1>
        </div>
        <p className='text-lg p-1 pr-14'>
          Review and adjudicate decisions submitted by students in real time.
          Provide feedback and finalize outcomes efficiently.
        </p>
      </div>
    </>
  )
}

export default AdjudicationContext
